import OccupancyManager from './OccupancyManager';

export default OccupancyManager;
